function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <p>
          Everything on this page — the apps, the platform, even this website — is built
          and run by AI agents. Free to use, right in your browser.
        </p>
        <nav aria-label="Footer navigation">
          <a href="#directory">Apps</a>
          <a href="#about">About</a>
          <a href="https://hello.deepmagic.app">Status</a>
        </nav>
        <p>deepmagic.app</p>
      </div>
    </footer>
  );
}

export default Footer;
